<template>
  <div v-loading="loading">
    <div class="content-list" @click="detailData.activeName ? active = false : ''">
      <el-row>
        <el-col class="left" :span="3">活动名称：</el-col>
        <el-col class="right g-flex-start" :span="20">
          <span v-if="!active">{{ detailData.activeName }}</span>
          <el-input v-else v-model="detailData.activeName" @change="changeName" :maxlength="30" @click.stop.native size="small"></el-input>
          <img v-if="!active" src="../../../../assets/image/modify.png" @click.stop="active = true" alt="">
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">创建时间：</el-col>
        <el-col class="right" :span="20">{{ detailData.createTime }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动油站：</el-col>
        <el-col class="right" :span="20">{{ detailData.gasName }}</el-col>
      </el-row>
      <el-row v-if="detailData.isFundUsed !== null && detailData.isFundUsed !== undefined">
        <el-col class="left" :span="5">是否使用营销基金：</el-col>
        <el-col class="right" :span="18">{{ detailData.isFundUsed === 0 ? '否' : '是' }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动信息：</el-col>
        <el-col lass="right" :span="20">
          <template v-if="isNewTable">
            <rule-card v-for="(item, index) in detailData.activityRegulation" :key="index" :data="item" :index="index"/>
          </template>
        </el-col>
      </el-row>
    </div>

    <!-- 明细表格 -->
    <el-table
      v-if="!isNewTable"
      :data="tableData"
      border
      max-height="300"
      style="width: 100%; margin-top: 20px;">
      <el-table-column
        prop="oilNoName"
        align="center"
        width="150"
        label="油号">
      </el-table-column>
      <el-table-column
        prop="rebate"
        align="center"
        width="150"
        label="让利">
        <template slot-scope="{row}">
          <span>
            {{row.rebate * 1000 / 10 + '%'}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="startTime"
        align="center"
        label="活动时间">
        <template slot-scope="{row}">
          <span>
            {{ formatTime(row) }}
          </span>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>
<script>
import { activeDetail, changeName } from '@/api/marketShop'
import dayjs from 'dayjs'
import ruleCard from '../../../marketPromotion/components/ruleCard.vue'

export default {
  name: 'stationOrder',
  props: ['detailType', 'id', 'show'],
  inject: ['resetData', 'getListData'],
  components: {
    ruleCard
  },
  data () {
    return {
      active: false,
      detailData: {},
      tableData: [],
      loading: false,
      isNewTable: 0
    }
  },
  methods: {
    // 初始化数据
    async initData () {
      this.loading = true
      try {
        const {code, result} = await activeDetail({activeId: this.id})
        if (code !== 200) return
        const { isNewTable, activeInfoNewResponse, activeInfoResponse } = result
        this.isNewTable = result.isNewTable
        if (isNewTable) {
          this.detailData = activeInfoNewResponse
        } else {
          this.detailData = activeInfoResponse
          this.tableData = activeInfoResponse.subActivityInfoList
        }
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    // 修改活动名称
    async changeName () {
      if (!this.detailData.activeName) {
        this.$message({
          message: '请输入活动名称',
          type: 'warning'
        })
        return
      }
      
      this.$track.clickEvent('活动营销-活动列表-活动详情-修改名称', '1632832589')

      try {
        const {code} = await changeName({activeName: this.detailData.activeName, activeId: this.id})
        if (code !== 200) return
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.active = false
        this.resetData(this.detailType)
        this.getListData(this.detailType)
      } catch (error) {
        console.log(error)
      }
    },
    formatTime (row) {
      return `${dayjs(row.startTime).format('YYYY-MM-DD')} 至 ${dayjs(row.endTime).format('YYYY-MM-DD')}`
    }
  },
  watch: {
    show (val) {
      val && this.initData()
      this.active = false
    }
  },
  mounted () {
    this.initData()
  }
}
</script>
<style lang="less" scoped>
  @import url('./style.less');
</style>